import React, { useState } from 'react';

const WidgetSelectBox = (props) => {
  //   const [sameCode, setSameCode] = useState(0);
  const preText = props.state.prevMessage;
  const _prev = () => {
    props.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };

  const _onChange = async (e) => {
    var target = document.getElementById('selectBox');
    const sameCode = target.options[target.selectedIndex].value;
    const sameName = target.options[target.selectedIndex].text;

    //console.log(sameCode, sameName);

    if (sameCode !== 0) {
      props.actionProvider._sameCodeSelect(sameName);
    }
  };
  return (
    <>
      <div className="select-container">
        <select onChange={_onChange} id="selectBox">
          <option value={0}>분기를 선택하세요.</option>
          {props.payload.list.map((item) => (
            <option value={item.sameCode} key={item.sameCode}>
              {item.sameName}
            </option>
          ))}
        </select>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetSelectBox;
